import axios from "axios";

export const adminApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    withCredentials: true,
});

export const apiErrorDetail = (err, fallback) => {
    const d = err?.response?.data?.detail;
    return typeof d === "string" ? d : fallback;
};

export const formatDate = (iso) =>
    new Date(iso).toLocaleString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
